import { useState } from 'react'
import { TradeDirection } from '~/components/Exchange/types'
import { useNeedApprove } from '../../hooks/useNeedApprove'
import TokenListModal from '../TokenListModal'
import { useLimitSwapPair } from '~/state/dex/hooks'
import Token from '~/components/Token'
import { useGA } from '~/hooks'

interface TokenSelectProps {
  direction: TradeDirection
}

const TokenSelect: React.FC<TokenSelectProps> = ({ direction }) => {
  const [inputToken, outputToken] = useLimitSwapPair()
  const needApprove = useNeedApprove()
  const selectedToken =
    direction === TradeDirection.Input ? inputToken : outputToken
  const [isOpen, setIsOpen] = useState(false)
  const { trackClick } = useGA()

  const onClick = () => {
    trackClick(
      `webtl_lo_${direction === TradeDirection.Input ? 'taker' : 'maker'}`,
    )
    setIsOpen(true)
  }

  return (
    <>
      <Token
        token={selectedToken}
        onClick={onClick}
        needApprove={direction === TradeDirection.Input && needApprove}
        testid={`limitorder-${direction}-token`}
      />

      <TokenListModal
        isOpen={isOpen}
        onDismiss={() => setIsOpen(false)}
        direction={direction}
      />
    </>
  )
}

export default TokenSelect
